import { render } from "./EventManagementForm.vue?vue&type=template&id=39391eb3&ts=true"
import script from "./EventManagementForm.vue?vue&type=script&lang=ts"
export * from "./EventManagementForm.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__